export enum UserRestWarningTypeEnum {
  ELEVEN_HOUR_WARNING = 'ELEVEN_HOUR_WARNING',
  SEVEN_DAY_WARNING = 'SEVEN_DAY_WARNING',
  POTENTIAL_SEVEN_DAY_WARNING = 'POTENTIAL_SEVEN_DAY_WARNING',
}

export type JobForRestWarning = {
  jobId: string;
  bookedUntil: Date;
  bookedFrom: Date;
};

interface UserRestWarningBase {
  type: UserRestWarningTypeEnum;
  affectedDates: string[];
}

export interface UserRestWarningSevenDay extends UserRestWarningBase {
  type: UserRestWarningTypeEnum.SEVEN_DAY_WARNING;
  bookedJobs: JobForRestWarning[];
  sevenDayWorkStart: Date;
  sevenDayWorkEnd: Date;
}

export interface UserRestWarningPotentialSevenDay extends UserRestWarningBase {
  type: UserRestWarningTypeEnum.POTENTIAL_SEVEN_DAY_WARNING;
  dayChains: {
    start: Date;
    end: Date;
    bookedJobs: JobForRestWarning[];
  }[];
  withBreakInfraction: boolean;
}

export interface UserRestWarningElevenHour extends UserRestWarningBase {
  type: UserRestWarningTypeEnum.ELEVEN_HOUR_WARNING;
  jobDate: string;
  bookedJob: JobForRestWarning;
}

export type UserRestWarning =
  | UserRestWarningSevenDay
  | UserRestWarningElevenHour
  | UserRestWarningPotentialSevenDay;
